export default "__VITE_ASSET__Cyhd583Z__"